import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    root: {
        display: 'block',
        maxWidth: '100%',
    },
}, {
    name: 'image',
});

export { useStyles };
